import request from "./request";

export const createRet00c = (data: any) =>
  request('/console/ret00cs', {
    method: 'POST',
    data,
  })

export const updateRet00c = (id: string, data: any) =>
  request(`/console/ret00cs/${id}`, {
    method: 'PUT',
    data,
  })

export const getRet00cDetail = (id: string) =>
  request(`/console/ret00cs/${id}`, {
    method: 'GET',
  })

export const destroyRet00c = (id: string | number) =>
  request(`/console/ret00cs/${id}`, {
    method: 'DELETE',
  })

export const getRet00cOverviewTree = () =>
  request<{ data: { items: any[] } }>('/console/ret00cs/overview_tree', {
    method: 'GET',
  })

export const createRet00ca = (ret00cId: string, data: any) =>
  request(`/console/ret00cs/${ret00cId}/ret00ca_create`, {
    method: 'POST',
    data,
  })

export const createRet00casBatch = (ret00cId: string, items: any[]) =>
  request(`/console/ret00cs/${ret00cId}/ret00cas_batch_create`, {
    method: 'POST',
    data: { items },
  })

export const updateRet00ca = (ret00cId: string, ret00caId: string | number, data: any) =>
  request(`/console/ret00cs/${ret00cId}/ret00cas/${ret00caId}`, {
    method: 'PUT',
    data,
  })

export const destroyRet00ca = (ret00cId: string, ret00caId: string | number) =>
  request(`/console/ret00cs/${ret00cId}/ret00cas/${ret00caId}`, {
    method: 'DELETE',
  })

export const getRet00ccs = (ret00cId: string) =>
  request(`/console/ret00cs/${ret00cId}/ret00ccs`, {
    method: 'GET',
  })
